import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TriggerDropdownDirective } from './trigger-dropdown.directive';
import { DropdownComponent } from './dropdown.component';
import { DropdownItemComponent } from './dropdown-item.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [TriggerDropdownDirective, DropdownComponent, DropdownItemComponent],
	imports: [CommonModule, MatTooltipModule],
	exports: [TriggerDropdownDirective, DropdownComponent, DropdownItemComponent],
})
export class DropdownModule {}
